import black from './black'
import elite from './elite'
import founder from './founder'
import sovereign from './sovereign'

export default [
  black,
  elite,
  founder,
  sovereign
] 
